<capra-search-input
  #trigger
  [matMenuTriggerFor]="menu"
  class="search-input"
  size="regular"
  placeholder="Add a recipient..."
  [autofocus]="true"
  [text]="searchText"
  (textChange)="inputChange($event)"
></capra-search-input>

<mat-menu #menu class="email-search-panel" yPosition="below" zPosition="before">
  <div *ngIf="showExternalDomainError$ | async; else searchResultsContent" class="domain-error">
    <p class="error-title">Emails can only be sent to members of your Workspace.</p>
    <p class="error-body">
      To use this email address,
      <a
        class="authorize-domain-link"
        [attr.href]="helpDocs.links['https://mode.com/help/articles/authentication-and-sso']"
        target="_blank"
        rel="noopener"
        >authorize the email domain</a
      >
      or enable External Sharing for this Report.
    </p>
    <p class="error-footer">
      <a
        [attr.href]="helpDocs.links['https://mode.com/help/articles/report-scheduling-and-sharing/#external-sharing']"
        target="_blank"
        rel="noopener"
        >Learn more about External Sharing</a
      >
    </p>
  </div>
  <ng-template #searchResultsContent>
    <mode-user-email
      *ngIf="externalEmail$ | async as externalEmail"
      class="external-email search-result"
      [email]="externalEmail + ' (external)'"
      (click)="userSelected(externalEmail)"
      data-test="email-search-result"
    ></mode-user-email>
    <mode-user-email
      *ngFor="let suggestedEmail of suggestedEmails$ | async"
      class="suggested-email search-result"
      [email]="suggestedEmail + ' (suggested)'"
      (click)="userSelected(suggestedEmail)"
      data-test="email-search-result"
    ></mode-user-email>
    <mode-user-email
      *ngFor="let user of searchResults"
      class="search-result"
      [name]="user.name"
      [email]="user.email"
      [avatar]="user.avatar"
      (click)="userSelected(user)"
      data-test="email-search-result"
    ></mode-user-email>
    <p
      *ngIf="
        ((suggestedEmails$ | async) === null || (suggestedEmails$ | async)?.length === 0) && searchResults.length === 0
      "
      class="no-matches-error"
    >
      No matches found.
    </p>
  </ng-template>
</mat-menu>
